import About from 'modules/About/About';
import AdminPanel from 'modules/AdminPanel/AdminPanel';
import BusinessTrips from 'modules/BusinessTrips';
import Clients from 'modules/Clients/Clients';
import EmploymentForms from 'modules/EmploymentForms/EmploymentForms';
import ManagerForm from 'modules/ManagerForm/ManagerForm';
import OrderReportingCompleteness from 'modules/OrderReporting/OrderReportingCompleteness';
import BulkOrderIssue from 'modules/Orders/BulkOrderIssue';
import BulkOrderRenew from 'modules/Orders/BulkOrderRenew';
import MyOrderDetails from 'modules/Orders/MyOrderDetails';
import MyOrders from 'modules/Orders/MyOrders';
import OrderDetails from 'modules/Orders/OrderDetails';
import OrderForm, { OrderRenewalForm } from 'modules/Orders/OrderForm';
import OrderOversight from 'modules/Orders/OrderOversight';
import Orders from 'modules/Orders/Orders';
import Projects from 'modules/Projects/Projects';
import Reports from 'modules/Reports/Reports';
import Timesheets from 'modules/Timesheets/Timesheets';
import UserProfile from 'modules/UserProfile/UserProfile';
import WorkTime from 'modules/WorkTime/WorkTime';

export default [
  { component: Timesheets, path: '/timesheets' },
  { component: WorkTime, path: '/worktime/:username' },
  { component: WorkTime, path: '/worktime' },
  { component: Reports, path: '/reports' },
  { component: Projects, path: '/projects' },
  { component: Clients, path: '/clients' },
  { component: EmploymentForms, path: '/employment-forms' },
  { component: MyOrderDetails, path: '/my-assignments/:orderNumber' },
  { component: MyOrders, path: '/my-assignments' },
  { component: OrderForm, path: '/assignments/new' },
  { component: BulkOrderIssue, path: '/assignments/bulk' },
  { component: BulkOrderRenew, path: '/assignments/bulk-extend' },
  { component: OrderOversight, path: '/assignments/oversight' },
  {
    component: OrderReportingCompleteness,
    path: '/assignments/reporting-completeness',
  },
  { component: OrderRenewalForm, path: '/assignments/:orderNumber/extend' },
  { component: OrderDetails, path: '/assignments/:orderNumber' },
  { component: Orders, path: '/assignments' },
  { component: ManagerForm, path: '/form' },
  { component: UserProfile, path: '/profile' },
  { component: About, path: '/about' },
  { component: AdminPanel, path: '/adminpanel' },
  { component: BusinessTrips, path: '/trips' },
  { component: WorkTime, route: '/' },
];
